export default {
  FETCH_START: 'FETCH_START',
  GET_BALANCE_SUCCESS: 'GET_BALANCE_SUCCESS',
  GET_COSTS_SUCCESS: 'GET_COSTS_SUCCESS',
  POST_INCOME_SUCCESS: 'POST_INCOME_SUCCESS',
  FETCH_ERROR: 'FETCH_ERROR',
  DATE_NOW: 'DATE_NOW',
  COSTS_POST_SUCCESS: 'COSTS_POST_SUCCESS',
  GET_INCOMES_SUCCESS: 'GET_INCOMES_SUCCESS',
  LOG_OUT: 'LOG_OUT',

  // Statistics
  GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
  COSTS_DELETE_SUCCESS: 'COSTS_DELETE_SUCCESS',
};
